var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.usablePromoCodes.length || _vm.order.promo_code
    ? _c(
        "div",
        { staticClass: "shadow-2 p-20 mob-p-15 bg-white radius-5 mt-20" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "mt-20" }, [
            !_vm.order.promo_code
              ? _c("div", [
                  _c("form", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-start-center p-10 border-dashed-grey1 radius-5",
                      },
                      [
                        _c("div", { staticClass: "has-float-label" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.codeForPromo,
                                expression: "codeForPromo",
                              },
                            ],
                            staticClass: "form-item fsize-18 text-bold",
                            attrs: {
                              id: "codepromo",
                              "data-cy": "promo-input",
                              placeholder: " ",
                              type: "text",
                            },
                            domProps: { value: _vm.codeForPromo },
                            on: {
                              focus: function ($event) {
                                _vm.onFocus = true
                              },
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.codeForPromo = $event.target.value
                                },
                                function ($event) {
                                  _vm.promoCodeErrorMsg = ""
                                },
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "mob-fsize-14 mob-pt-5 color-grey4",
                              attrs: { for: "codepromo" },
                            },
                            [_vm._v("Insérer le code")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "small",
                            class: [
                              _vm.onFocus == false || _vm.codeForPromo == ""
                                ? "btnFlat-grey2"
                                : "btnFlat-ok",
                            ],
                            attrs: {
                              disabled:
                                _vm.onFocus == false || _vm.codeForPromo == "",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.useCodeForPromo()
                              },
                            },
                          },
                          [_vm._v("\n\t\t\t\t\t\tValider\n\t\t\t\t\t")]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.promoCodeErrorMsg
                    ? _c("div", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.promoCodeErrorMsg)),
                      ])
                    : _vm._e(),
                ])
              : _c(
                  "div",
                  {
                    staticClass:
                      "border-bo-p2 color-bo-p2 flex-center-center p-10 radius-5",
                  },
                  [
                    _c("div", { staticClass: "text-uppercase m-5" }, [
                      _vm._v(
                        "Vous économisez " +
                          _vm._s(_vm.ShopService.prix(_vm.order.Discount))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "fsize-26 fie-icon_confirmed m-5" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "close rounded-btn display-1 p-10 bg-grey3",
                        attrs: {
                          type: "button",
                          title: "Enlever le coupon",
                          "aria-label": "Enlever le coupon",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.PromoService.setPromoCode(
                              null,
                              _vm.order
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "font-lato text-light",
                            attrs: { "aria-hidden": "true" },
                          },
                          [_vm._v("×")]
                        ),
                      ]
                    ),
                  ]
                ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex-start-center mb-20" }, [
      _c("i", { staticClass: "fsize-26 mob-fsize-22 fie-icon_discount mr-10" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "color-grey1 text-uppercase text-bold fsize-16 mob-fsize-14",
        },
        [_vm._v("Utiliser un code coupon ?")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }